export default "__VITE_ASSET__58721021__"